import { useState } from "react";
import TuneIcon from "@mui/icons-material/Tune";
import { Tooltip, TextField, MenuItem } from "@mui/material";
import getColumns from "./column.js";
import DynamicTable from "../../../components/common/DynamicTable.jsx";
import useModal from "../../../hooks/useModal.js";
import { getPayBasisList, PAY_BASIS_OPTIONS } from "../../../services/payBasis.js";
import AddEditPayBasis from "./AddEditPayBasis.jsx";
import usePaginatedList from "../../../hooks/usePaginatedList.js";

const PayBasisList = () => {
  const { showModal } = useModal();
  const [showFilter, setShowFilter] = useState(false);
  const [filterValues, setFilterValues] = useState({});

  const fetchData = async (params) => {
    return await getPayBasisList(params.page, params);
  };

  const { data, pagination, setPage, setItemsPerPage, setFilters, refresh } = usePaginatedList(fetchData);

  const handleApplyFilters = () => {
    setFilters({ filters: filterValues });
    setShowFilter(false);
  };

  const handleClearFilters = () => {
    setFilterValues({});
    setFilters({ filters: {} });
    setShowFilter(false);
  };

  const handleEdit = (row) => {
    showModal("Change Pay Basis", <AddEditPayBasis refresh={refresh} existingField={row} />);
  };

  return (
    <>
      <div className="bg-light mb-2">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div className="d-flex align-items-center gap-2">
              <label className="mb-0 text-muted small">Show</label>
              <select
                className="form-select form-select-sm"
                style={{ width: "80px" }}
                value={pagination?.itemsPerPage || 20}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="text-muted small">entries</span>
            </div>

            <div className="d-flex gap-2 flex-wrap">
              <Tooltip title="Filter">
                <button className="btn btn-outline-dark btn-sm" onClick={() => setShowFilter(!showFilter)}>
                  <TuneIcon sx={{ fontSize: 18 }} />
                </button>
              </Tooltip>
            </div>
          </div>

          {showFilter && (
            <div className="d-flex flex-wrap gap-2 mt-3">
              <TextField
                select
                size="small"
                label="Pay Basis"
                style={{ minWidth: 180 }}
                value={filterValues.pay_basis || ""}
                onChange={(e) => setFilterValues((prev) => ({ ...prev, pay_basis: e.target.value }))}
              >
                <MenuItem value="">All</MenuItem>
                {PAY_BASIS_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </TextField>
              <button className="btn btn-danger btn-sm" onClick={handleApplyFilters}>
                Apply
              </button>
              <button className="btn btn-secondary btn-sm" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
          )}
        </div>
      </div>

      <DynamicTable
        columns={getColumns(handleEdit)}
        data={data}
        rowKey="employee_id"
        currentPage={pagination?.currentPage}
        totalPages={pagination?.totalPages}
        itemsPerPage={pagination?.itemsPerPage}
        totalItems={pagination?.totalItems}
        onPageChange={(page) => setPage(page)}
      />
    </>
  );
};

export default PayBasisList;
